export const testimonials = [
  {
    id: 1,
    name: 'Sarah Mueller',
    title: 'Marketing Manager, Berlin',
    rating: 5,
    quote: 'FreshMeals has completely transformed my lunch routine. The quality is outstanding and the convenience is unbeatable. I love that I can focus on my work instead of meal planning.',
    image: 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20confident%20young%20woman%20with%20blonde%20hair%20in%20business%20casual%20attire%2C%20smiling%20warmly%2C%20clean%20white%20background%2C%20natural%20lighting%2C%20professional%20photography&width=200&height=200&seq=testimonial-001&orientation=squarish',
  },
  {
    id: 2,
    name: 'Michael Schmidt',
    title: 'Software Developer, Munich',
    rating: 5,
    quote: 'As someone who works long hours, having healthy meals delivered is a game-changer. The variety is amazing and everything tastes restaurant-quality. Highly recommend!',
    image: 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20friendly%20young%20man%20with%20dark%20hair%20wearing%20casual%20shirt%2C%20smiling%20confidently%2C%20clean%20white%20background%2C%20natural%20lighting%2C%20professional%20photography&width=200&height=200&seq=testimonial-002&orientation=squarish',
  },
  {
    id: 3,
    name: 'Anna Weber',
    title: 'Fitness Coach, Hamburg',
    rating: 5,
    quote: 'The nutritional balance is perfect for my active lifestyle. I appreciate the transparency about ingredients and calories. Best meal delivery service I have tried in Germany.',
    image: 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20athletic%20young%20woman%20with%20brown%20hair%20in%20sporty%20attire%2C%20bright%20smile%2C%20clean%20white%20background%2C%20natural%20lighting%2C%20professional%20photography&width=200&height=200&seq=testimonial-003&orientation=squarish',
  },
  {
    id: 4,
    name: 'Thomas Becker',
    title: 'CEO, Frankfurt',
    rating: 5,
    quote: 'We switched our entire office to FreshMeals corporate plan. Employee satisfaction has increased significantly and the ordering process is seamless. Excellent service!',
    image: 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20mature%20businessman%20with%20gray%20hair%20in%20business%20suit%2C%20confident%20expression%2C%20clean%20white%20background%2C%20natural%20lighting%2C%20professional%20photography&width=200&height=200&seq=testimonial-004&orientation=squarish',
  },
];